


























import {
  useLocalFilter,
  useMapMasterTypeToOptionAlt,
  useSalesOrder,
} from "@/hooks";
import { Option } from "@/models/class/option.class";
import { SalesOrderTypeEnum } from "@/models/enums/SalesOrderType.enum";
import { ResponseListMaster } from "@/models/interface/contact.interface";
import { Component, Prop, Vue } from "vue-property-decorator";

type SalesTypeEnum = "SALES_ORDER" | "CUSTOMER_RETURN"
const SALES_TYPE_TRUCKING = "Trucking"

@Component
export default class SelectSalesType extends Vue {
  @Prop({ required: true, type: String, default: "" }) value!: string;
  @Prop({ required: false, type: Boolean, default: false }) disabled!: boolean;
  @Prop({ required: false, type: String, default: "SALES_ORDER" }) mode!: SalesTypeEnum;

  useLocalFilter = useLocalFilter;

  options: Option[] = [];
  loading = false;

  created(): void {
    this.fetchOptions();
  }

  onChange(e: string): void {
    this.$emit("input", e);
    this.$emit("change", e);
  }

  filterOptionsByProps(data: ResponseListMaster[]): void {
    let filteredTypes = data.filter(item => item.value.toUpperCase() !== SALES_TYPE_TRUCKING.toUpperCase());

    if (this.mode === "CUSTOMER_RETURN") {
      filteredTypes = filteredTypes.filter(
        item =>
          item.value.toUpperCase() !== SalesOrderTypeEnum.RENT.toUpperCase() &&
          item.value.toUpperCase() !== SalesOrderTypeEnum.OTHERS.toUpperCase()
      );
    }

    this.options = useMapMasterTypeToOptionAlt(filteredTypes);
  }

  fetchOptions(): void {
    const { findAllSoType } = useSalesOrder();
    this.loading = true;
    findAllSoType()
      .then(res => {
        this.filterOptionsByProps(res);
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
